import { render, staticRenderFns } from "./SchoolAccountTerms.vue?vue&type=template&id=d913bdc8"
import script from "./SchoolAccountTerms.vue?vue&type=script&lang=ts"
export * from "./SchoolAccountTerms.vue?vue&type=script&lang=ts"
import style0 from "./SchoolAccountTerms.vue?vue&type=style&index=0&id=d913bdc8&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d913bdc8')) {
      api.createRecord('d913bdc8', component.options)
    } else {
      api.reload('d913bdc8', component.options)
    }
    module.hot.accept("./SchoolAccountTerms.vue?vue&type=template&id=d913bdc8", function () {
      api.rerender('d913bdc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/SchoolAccountTerms.vue"
export default component.exports